export default "__VITE_ASSET__DZ_WWQKo__"